module.exports = __webpack_public_path__ + "img/osbod_background_whatsapp.ac71bcc2.jpg";